<template>
  <span class="py-3 text-center text-gray-700 md:py-2">
    <span class="font-bold">{{ itemsStart }} - {{ itemsEnd }}</span> of
    <span class="font-bold">{{ numberOfItems }}</span>
  </span>
</template>

<script>
export default {
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      required: true
    },
    numberOfItems: {
      type: Number,
      required: true
    }
  },
  computed: {
    itemsStart() {
      if (this.numberOfItems == 0) {
        return 0;
      }
      return (this.currentPage - 1) * this.perPage + 1;
    },
    itemsEnd() {
      const n = this.perPage * this.currentPage;
      if (n > this.numberOfItems) return this.numberOfItems;

      return n;
    }
  }
};
</script>
